<template>
  <v-layout>
      <v-flex>
        <v-data-table
        :headers="headers"
        :items="datos"        
        :search="search"
        class="elevation-1"
        :loading="loadigtable"
        loading-text="Loading... Please wait"
        >
        <template v-slot:[`item.condicion`]="{ item }">  
            <div v-if="item.condicion">
                <span class="blue--text">Activo</span>
            </div>
            <div v-else>
                <span class="red--text">Inactivo</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Informacion Agentes / Clientes / Proveedores</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-btn color="primary" dark class="mb-2" @click="dialog=true">Nuevo</v-btn>
                <v-dialog v-model="dialog" max-width="850px" scrollable>
                    <v-card>
                        <v-toolbar>
                                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-progress-linear
                                    :active="loadingsave"
                                    indeterminate=3000
                                    absolute
                                    bottom
                                    color="primary accent-6"
                                ></v-progress-linear>
                            </v-toolbar>
                            <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-btn-toggle
                                    v-model="optionsbutton"
                                    tile
                                    color="#055a7f"
                                    style="border: 1px solid;"
                                    dense
                                    group
                                    multiple>
                                        <v-btn value="cliente" @click="clienteview()">
                                            Cliente 
                                        </v-btn>  
                                        <v-btn value="agente" @click="agenteview()">
                                            Agente
                                        </v-btn>
                                        <v-btn value="proveedor">
                                            Proveedor
                                        </v-btn>
                                        <!--<v-btn value="transportista">
                                            Transportista
                                        </v-btn>-->
                                </v-btn-toggle>
                                <v-spacer></v-spacer> 
                                    <v-switch
                                    v-model="propogl"
                                    label="PROPIETARIO OGL"
                                    ></v-switch>
                            </v-row><br>
                            <v-row>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field v-model="razonsocial" label="* Razón social"></v-text-field>
                                </v-col> 
                                <v-col cols="3" sm="3" md="3">
                                    <v-text-field v-model="rfc" label="* RFC / Tax ID"></v-text-field>
                                </v-col> 
                                <v-col cols="3" sm="3" md="3">
                                    <v-select v-model="pais" :items="paises" label="* Pais">
                                    </v-select>
                                </v-col>  
                                <v-col cols="12" sm="12" md="12" >
                                    <v-textarea
                                        v-model="direccion"
                                        outlined
                                        name="input-7-4"
                                        label="* Direccion"
                                        ></v-textarea>
                                </v-col>                                             
                            </v-row> 
                            <v-row v-if="clientesview === true">
                                <v-col>
                                    <v-card class="mx-auto" style="padding: 12px;margin-bottom: 8px;">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <span style="font-weight: 600;color: #115bb7;">Facturación</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                             <v-col cols="6" sm="6" md="6" >
                                                <v-select v-model="idusocfdi" :items="UsoCfdi" label="* Uso de CFDI">
                                                </v-select>
                                            </v-col>  
                                            <v-col cols="6" sm="6" md="6" >
                                                <v-select v-model="idfmpago" :items="FormasdePagos" label="* Forma de Pago">
                                                </v-select>
                                            </v-col>   
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row v-if="agentesview === true">
                                <v-col>
                                    <v-card class="mx-auto" style="padding: 12px;margin-bottom: 8px;">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <span style="font-weight: 600;color: #115bb7;">BANK ACCOUNT</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4" sm="4" md="4">
                                                <v-text-field v-model="bankname" label="* Bank name:"></v-text-field>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <v-text-field v-model="account" label="* Bank account no:"></v-text-field>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <v-text-field v-model="currency" label="* Currency:"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-text-field v-model="aba" label="ABA/IBAN/BIC:"></v-text-field>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-text-field v-model="swift" label="SWIFT:"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-textarea
                                                    v-model="bankaddress"
                                                    outlined
                                                    name="input-7-4"
                                                    label="* Bank address:"
                                                    ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-card class="mx-auto">
                                            <v-list-item two-line>
                                            <v-list-item-content>                                                        
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>Contactos</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>                                                                    
                                                </v-toolbar>                                                              
                                                <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-card-text style="padding-top: 0; padding-bottom: 0;">                                                    
                                            <v-row align="center">
                                                <v-col md="6">
                                                    <v-text-field v-model="editcontact.nombre" label="*Nombre contacto"></v-text-field>
                                                </v-col>
                                                <v-col sm="6" md="3">
                                                    <v-text-field v-model="editcontact.puesto" label="Puesto"></v-text-field>
                                                </v-col>
                                                <v-col sm="6" md="3">
                                                    <v-text-field v-model="editcontact.telefono" label="Teléfono"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editcontact.celular" label="Celular"></v-text-field>                                                            
                                                </v-col>
                                                <v-col >
                                                    <v-text-field v-model="editcontact.correo" label="*Correo"></v-text-field>
                                                </v-col>                                                        
                                            </v-row>    
                                            <v-row>
                                                <v-col style="display: flex;flex-direction: row-reverse;margin-bottom: 10px;">
                                                    <v-btn small color="primary" @click="agregar" dark>Agregar</v-btn>
                                                </v-col>
                                            </v-row>                                                 
                                            <v-row>
                                                <v-col  style="padding-bottom: 10px;">
                                                    <v-data-table
                                                    :headers="headersc"
                                                    :items="contactos"
                                                    sort-by="calories"
                                                    class="elevation-1"
                                                    >
                                                    <template v-slot:[`item.activo`]="{ item }">  
                                                        <div v-if="item.activo">
                                                            <span class="blue--text">Activo</span>                
                                                        </div>
                                                        <div v-else>
                                                            <span class="red--text">Inactivo</span>                
                                                        </div>                  
                                                    </template>
                                                    <template v-slot:[`item.opciones`]="{ item }">
                                                                <v-icon
                                                                small
                                                                class="mr-2"
                                                                @click="editItemc(item)"
                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                color="#3d5170"
                                                                >
                                                                edit
                                                                </v-icon>
                                                                <template v-if="item.activo">
                                                                    <v-icon
                                                                        small
                                                                        class="mr-2"
                                                                        @click="activarDesactivarMostrar(2,item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                        </v-icon>                               
                                                                </template>                                                             
                                                    </template>     
                                                        <template v-slot:no-data>
                                                            <v-btn color="primary" @click="initialize">Reset</v-btn>
                                                        </template>
                                                    </v-data-table>                                                            
                                                </v-col>
                                            </v-row>                                                    
                                        </v-card-text>                                                
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>               
            </v-toolbar>
        </template>
        
        <template v-slot:[`item.opciones`]="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            edit
            </v-icon>           
        </template>
        <template v-slot:[`item.esproveedor`]="{ item }">
            <template v-if="item.esproveedor === true">
                <v-icon
                small
                class="mr-2"
                style="color: #4CAF50;font-weight: 600;"
                >
                done
                </v-icon>  
            </template>
            <template v-else>
                <v-icon
                small
                class="mr-2"
                style="color: red;font-weight: 600;"
                >
                clear
                </v-icon> 
            </template>
        </template>
        <template v-slot:[`item.escliente`]="{ item }">
            <template v-if="item.escliente === true">
                <v-icon
                small
                class="mr-2"
                style="color: #4CAF50;font-weight: 600;"
                >
                done
                </v-icon>  
            </template>
            <template v-else>
                <v-icon
                small
                class="mr-2"
                style="color: red;font-weight: 600;"
                >
                clear
                </v-icon> 
            </template>
        </template>
        <template v-slot:[`item.esagente`]="{ item }">
            <template v-if="item.esagente === true">
                <v-icon
                small
                class="mr-2"
                style="color: #4CAF50;font-weight: 600;"
                >
                done
                </v-icon>  
            </template>
            <template v-else>
                <v-icon
                small
                class="mr-2"
                style="color: red;font-weight: 600;"
                >
                clear
                </v-icon> 
            </template>
        </template>
        <template v-slot:[`item.estransportista`]="{ item }">
            <template v-if="item.estransportista === true">
                <v-icon
                small
                class="mr-2"
                style="color: #4CAF50;font-weight: 600;"
                >
                done
                </v-icon>  
            </template>
            <template v-else>
                <v-icon
                small
                class="mr-2"
                style="color: red;font-weight: 600;"
                >
                clear
                </v-icon> 
            </template>
        </template>
        <template v-slot:[`item.activo`]="{ item }">
            <template v-if="item.activo === true">
                <v-icon
                small
                class="mr-2"
                style="color: #4CAF50;font-weight: 600;"
                >
                done
                </v-icon>  
            </template>
            <template v-else>
                <v-icon
                small
                class="mr-2"
                style="color: red;font-weight: 600;"
                >
                clear
                </v-icon> 
            </template>
        </template>   
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                     
    </v-flex>
  </v-layout>
</template>


<script>
import axios from 'axios'      
export default {
    data(){
        return{
            loadingsave:false,
            generalview:false,
            clientesview:false,
            agentesview:false,
            datos:[], 
            optionsbutton:[],
             adModal:false,            
             dialog: false,
                headers: [
                { text: 'OPCIONES', value: 'opciones', sortable: false,align:'center' },                        
                { text: 'NOMBRE', value: 'razon_social',align:'justify'},
                { text: 'PROVEEDOR', value: 'esproveedor',align:'center'},
                { text: 'CLIENTE', value: 'escliente', align:'center'},
                { text: 'AGENTE', value: 'esagente', align:'center'},
                { text: 'TRANSPORTISTA', value: 'estransportista', align:'center'},
                { text: 'ESTADO', value: 'activo', align:'center'},
                ],
                search:'',
                editedIndex: -1,              
                id:'',                
                nombre:'',
                tipo_documento:'',
                num_documento:'',
                telefono:'',
                email:'',                                                                                
                valida:'',
                validaMensaje:[],                
                adAccion:0,
                adNombre:'',
                adId:'',
                FormasdePagos:[],
                UsoCfdi:[],
                paises:[],
          /*********************CONTACTOS********************** */
                editcontact:{
                    idcontacto:'',
                    nombre:'',
                    puesto:'',
                    telefono:'',
                    celular:'',
                    correo:'',            
                },
                contactos:[],
                headersc: [
                    { text: 'OPCIONES', value: 'opciones', sortable: false },        
                    { text: 'NOMBRE', value: 'nombre' },
                    { text: 'PUESTO', value: 'puesto' },
                    { text: 'TELÉFONO', value: 'telefono' },
                    { text: 'CELULAR', value: 'celular' },
                    { text: 'CORREO', value: 'correo', sortable: false },
                    { text: 'ESTADO', value: 'activo' },
                ],
                adModalc:false,
            /*********************DATOS********************** */
            razonsocial:'',
            rfc:'',
            pais:0,
            direccion:'',
            idusocfdi:0,
            idfmpago:0,
            bankname:'',
            account:'',
            currency:'',
            aba:'',
            swift:'',
            bankaddress:'',
            editedIndexd:-1,
            iddatos:0,
            propogl:false,
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'Nuevo Cliente / Proveedor / Agente' : 'Actualizar Cliente / Proveedor / Agente'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },
    created () {
        this.select();  
        this.listar();
    },
    methods:{        
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            me.loadigtable = true;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Datos/Listar',configuracion).then(function(response){
              console.log('listado de datos')
              console.log(response);
              me.datos=response.data;
              me.loadigtable = false;
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var formadepagosarray = [];  
            var usodecfdiarray = [];
            var paisesArray=[];

            axios.get('api/FormadePagos/Select',configuracion).then(function(response){
                formadepagosarray=response.data;
                formadepagosarray.map(function(x){
                    me.FormasdePagos.push({text:x.clave + ' ' + x.nombre,value:x.idformadepago});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/UsoCfdis/Select',configuracion).then(function(response){
                usodecfdiarray=response.data;
                usodecfdiarray.map(function(x){
                    me.UsoCfdi.push({text:x.clave + ' ' + x.nombre,value:x.idusocfdi});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Paises/Select',configuracion).then(function(response){
              //console.log(response);
              paisesArray=response.data;
              paisesArray.map(function(x){
                  me.paises.push({text:x.nombre,value:x.idpais});
              });            
            }).catch(function(error){
              console.log(error);
            }); 
        },
        editItem(item){
            this.limpiar();
            this.editedIndexd = this.datos.indexOf(item)
            this.razonsocial = item.razon_social,
            this.rfc = item.rfc;
            this.pais = item.idpais;
            this.direccion = item.direccion;
            this.idusocfdi = item.idusocfdi;
            this.idfmpago = item.idusofmpago;
            this.bankname = item.bankname;
            this.account = item.banckaccount;
            this.currency = item.currency;
            this.aba = item.abaibanbic;
            this.swift = item.swift;
            this.bankaddress = item.bankaddress;
            this.dialog = true;
            this.iddatos = item.iddatos;
            var i;
            this.propogl = item.propietario;

            if(item.escliente == true){
                this.optionsbutton[0] = 'cliente';
                this.clientesview = true;
            }
            if(item.esagente == true){
                this.optionsbutton[1] = 'agente';
                this.agentesview = true;
            }
            if(item.esproveedor == true){
                this.optionsbutton[2] = 'proveedor';
            }
            if(item.estransportista == true){
                this.optionsbutton[3] = 'transportista';
            }
            this.listarContacto(item.iddatos);
        },
        listarContacto(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Contactos/ListarContactoDato/'+id,configuracion).then(function(response){            
                me.contactos=response.data;
            }).catch(function(error){
                console.log(error);
            });
        },
        close(){
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.razonsocial = '';
            this.rfc = '';
            this.pais = 0;
            this.direccion = '';
            this.idusocfdi = 0;
            this.idfmpago = 0;
            this.bankname = '';
            this.account = '';
            this.currency = '';
            this.aba = '';
            this.swift = '';
            this.bankaddress = '';
            this.editedIndexd =-1;
            this.dialog = false;
            this.contactos = [];
            this.optionsbutton = [];
            this.clientesview = false;
            this.agentesview = false;
            this.propogl = false;

        },
        guardar(){

            
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;


            me.loadingsave = true;
            var transportista = 0;
            var proveedor = 0;
            var agente = 0;
            var cliente = 0;
            var i;



            for (i = 0; i < me.optionsbutton.length; i++) {
                if(me.optionsbutton[i] == 'transportista'){
                    transportista = 1;
                }
                if(me.optionsbutton[i] == 'proveedor'){
                    transportista = 1;
                    proveedor = 1;
                }
                if(me.optionsbutton[i] == 'agente'){
                    transportista = 1;
                    agente = 1;
                }
                if(me.optionsbutton[i] == 'cliente'){
                    cliente = 1;
                }
            }
            if(me.razonsocial != '' || me.rfc != '' || me.direccion!= '' ){
                if(me.contactos.length >= 1 || transportista == 1 && proveedor == 0 && cliente == 0 && agente == 0){
                    if (this.editedIndexd > -1) {//codigo para editar
                        axios.put('api/Datos/Actualizar',{
                            'iddatos':me.iddatos,
                            'razon_social':me.razonsocial,
                            'rfc':me.rfc,
                            'idpais':me.pais,
                            'direccion':me.direccion,
                            'idusocfdi':me.idusocfdi,
                            'idusofmpago':me.idfmpago,
                            'bankname':me.bankname,
                            'banckaccount':me.account,
                            'currency':me.currency,
                            'abaibanbic':me.aba,
                            'swift':me.swift,
                            'bankaddress':me.bankaddress,
                            'esproveedor':proveedor,
                            'escliente':cliente,
                            'estransportista':transportista,
                            'esagente':agente,
                            'propietario':me.propogl
                        },configuracion).then(function(response){
                            me.close();
                            me.listar();
                            me.limpiar();
                            me.loadingsave = false;
                        }).catch(function(error){
                            console.log(error);
                        });  
                    } else {//codigo para guardar
                        axios.post('api/Datos/Crear',{ 
                            'razon_social':me.razonsocial,
                            'rfc':me.rfc,
                            'idpais':me.pais,
                            'direccion':me.direccion,
                            'idusocfdi':me.idusocfdi,
                            'idusofmpago':me.idfmpago,
                            'bankname':me.bankname,
                            'banckaccount':me.account,
                            'currency':me.currency,
                            'abaibanbic':me.aba,
                            'swift':me.swift,
                            'bankaddress':me.bankaddress,
                            'esproveedor':proveedor,
                            'escliente':cliente,
                            'estransportista':transportista,
                            'esagente':agente,
                            'contactos':me.contactos,
                            'propietario':me.propogl
                        },configuracion).then(function(response){
                            me.listar();
                            me.limpiar();
                            console.log(response.data)
                            console.log('Guardado')
                            me.loadingsave = false;
                        }).catch(function(error){
                            console.log(error);
                        });                
                    }
                }else{
                    window.alert('Agregar por lo menos un contacto')
                }
            }else{
                window.alert('Agregar los campor marcados con *')
            }
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];

            if(this.nombre.length<3 || this.nombre.length>100){
                this.validaMensaje.push("El nombre debe tener mas de 3 caracteres y menos de 100 caracteres.");
            }
            if(!this.tipo_documento){
                this.validaMensaje.push("Seleccione un tipo de documento.");
            }            
            if(this.validaMensaje.length){
                this.valida=1;
            } 
            return this.valida;
        },  
        agregar(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;

            if(model.editcontact.nombre === '' || model.editcontact.correo === ''){        
                model.adModalcontact = true;
            }else
            {
                 if (model.editedIndexd > -1) {
                     if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)    
                        axios.put('api/Contactos/Actualizar',{
                            'idcontacto': model.editcontact.idcontacto,                            
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'idpropietario' : model.iddatos
                        },configuracion).then(function(response){                                                                       
                            model.editedIndex = -1;                            
                            model.limpiarC();
                            model.snackbar = true;
                            model.mensaje = 'Contacto Actualizado'                                                      
                        }).catch(function(error){
                            console.log(error);
                        });  

                    } else {  
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        })                      
                         axios.post('api/Contactos/Crear',{
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'propietario' : 'DAT',
                            'idpropietario' : model.iddatos
                        },configuracion).then(function(response){                                  
                            model.limpiarC();
                            model.snackbar = true;
                            model.mensaje = 'Contacto guardado  ' 
                        }).catch(function(error){                                                
                            console.log(error); 
                        });                                      
                    }                    
                }
                else{
                    if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)
                        model.editedIndex = -1;
                    } else {                        
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        }) 
                    }
                }
                model.limpiarC(); 
            }

        },
        limpiarC(){
            this.editcontact.nombre = "";
            this.editcontact.puesto = "";
            this.editcontact.telefono= "";
            this.editcontact.celular = "";
            this.editcontact.correo = "";        
            this.editedIndex = -1;
        },  
        editItemc(item){
            this.editedIndex = this.contactos.indexOf(item)
            this.editcontact = Object.assign({}, item)
        },
        activarDesactivarMostrar(accion,item){
           this.adModalc=true;
           this.adNombre=item.nombre;
           this.adId=item.idprospecto;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModalc=false;
            }
        },
        clienteview(){

            if(this.clientesview == false){
                this.clientesview = true;
            }else{
                this.clientesview = false;
            }    
        },
        agenteview(){
            if(this.agentesview == false)
            {
                this.agentesview = true;
            }else{
                this.agentesview = false;
            }
        },
    }
}
</script>